import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Switch } from 'react-router-dom'
import AuthRouter from './AuthRouter'
import { userList } from '../actions/user'
import 'react-notifications/lib/notifications.css'
import {NotificationContainer} from 'react-notifications'

class MainRouter extends Component {

    componentDidMount() {
        const { dispatch } = this.props
    }

    componentDidUpdate() {
        const { dispatch } = this.props
        dispatch(userList.ensureUserLoaded())
    }

    render() {
        return (
            <div>
              <NotificationContainer />
              <AuthRouter />
            </div>
        )
    }
}
function mapStateToProps(state) {
    
    return {
    }
}
export default connect(mapStateToProps)(MainRouter)
